import * as React from 'react';
import { EqualHeightContext, } from '../equal-height-provider/equal-height-provider-core';
const EqualHeight = (props) => {
    const context = React.useContext(EqualHeightContext);
    const element = React.useRef(null);
    const { elementRef } = props;
    const getHeightByElement = React.useCallback((element, elementGroup) => {
        const groupKey = Object.keys(context.groupHeights).find((key) => key === elementGroup);
        if (groupKey) {
            const elGroup = context.groupHeights[groupKey].find((group) => group.elements.includes(element));
            return elGroup ? elGroup.height : 0;
        }
        return 0;
    }, [context.groupHeights]);
    const setElement = React.useCallback((e) => {
        element.current = e;
        if (elementRef && e) {
            elementRef(e);
        }
    }, [elementRef]);
    return (React.createElement(EqualHeightInner, Object.assign({}, props, context, { height: element.current ? getHeightByElement(element.current, props.group) : 0, elementRef: setElement, contextImageComponent: context.imageComponent, imageComponent: props.imageComponent })));
};
const EqualHeightInner = (props) => {
    const { align, className, elementRef, addElementToGroup, group, groupHeights, height, children, imageComponent, contextImageComponent, triggerUpdate, onHeightChange, } = props;
    const element = React.useRef(null);
    const firstHeightChange = React.useRef(true);
    React.useEffect(() => {
        triggerUpdate();
    }, [children, triggerUpdate]);
    React.useEffect(() => {
        if (firstHeightChange.current) {
            firstHeightChange.current = false;
            return;
        }
        if (onHeightChange) {
            onHeightChange();
        }
    }, [height, onHeightChange]);
    const BEM = () => {
        const classArray = ['equal-height'];
        if (align) {
            classArray.push('equal-height--' + align);
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    React.useEffect(() => {
        if (element.current !== null) {
            if (elementRef) {
                elementRef(element.current);
            }
            addElementToGroup(group, element.current);
        }
    }, [addElementToGroup, elementRef, group]);
    const getStyle = () => {
        if (element.current) {
            if (!groupHeights || Object.keys(groupHeights).length === 0) {
                return undefined;
            }
            return {
                minHeight: height + 'px',
            };
        }
    };
    const renderChildren = (children) => {
        return React.Children.map(children, (child) => {
            if (!React.isValidElement(child)) {
                return child;
            }
            // only provide props to EqualHeight that has same group name as provider.
            if (child.type === imageComponent || child.type === contextImageComponent) {
                return React.cloneElement(child, {
                    onLoad: (event) => {
                        triggerUpdate();
                        if (child.props.onLoad) {
                            child.props.onLoad(event);
                        }
                    },
                });
            }
            else if (child.props.children) {
                return React.cloneElement(child, {
                    children: renderChildren(child.props.children),
                });
            }
            return child;
        });
    };
    return (React.createElement("div", { className: BEM(), ref: element, style: getStyle() },
        React.createElement("div", { className: "equal-height__inner" }, renderChildren(children))));
};
export { EqualHeight as default, EqualHeightInner, };
